(function () {
  const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

  const revealSection = (section) => {
    section.classList.add('lazy-section--loaded');
  };

  const getLazySections = (root) => {
    if (!root) return [];

    const sections = [];
    if (root.classList && root.classList.contains('lazy-section')) {
      sections.push(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('.lazy-section').forEach((section) => {
        sections.push(section);
      });
    }

    return sections.filter((section) => !section.classList.contains('lazy-section--loaded'));
  };

  let observer;

  const ensureObserver = () => {
    if (observer || isDesignMode) return observer;

    observer = new IntersectionObserver((entries, obs) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;

        revealSection(entry.target);
        obs.unobserve(entry.target);
      }
    }, {
      rootMargin: '300px 0px',
      threshold: 0.01
    });

    return observer;
  };

  const bindSections = (sections) => {
    if (!sections.length) return;

    // Theme editor: show immediately so new/selected sections are visible without Save.
    if (isDesignMode) {
      for (const section of sections) {
        revealSection(section);
      }
      return;
    }

    const sectionObserver = ensureObserver();
    for (const section of sections) {
      sectionObserver.observe(section);
    }
  };

  const init = () => {
    bindSections(getLazySections(document));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindSections(getLazySections(event.target));
  });
})();
